export const STATUS_BADGE_CLASS = {
  'Open': 'badgeOpen',
  'In Review': 'badgeReview',
  'Pending Response': 'badgePending',
  'Resolved': 'badgeResolved',
  'Closed': 'badgeClosed',
  'ReOpened': 'badgeReopened',
};

export const STATUS_COLORS = {
  'Open': '#3b82f6',
  'In Review': '#a855f7',
  'Pending Response': '#f59e0b',
  'Resolved': '#10b981',
  'Closed': '#6b7280',
  'Re-opened': '#ef4444',
  'In Progress': '#f97316',
};
export function formatDate(d) {
  if (!d) return '—';
  const dt = new Date(d + 'T00:00:00');
  return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
